const getAssetType = (stringifiedMetaData) => {
  try {
    const metaData = JSON.parse(stringifiedMetaData);
    const type = metaData.type ? metaData.type.split('/') : '';

    if (type) {
      return type[0];
    }

    return '';
  } catch (e) {
    return '';
  }
};

export default getAssetType;